import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import './onboarding.css'
// import logoPretzu from '../../assets/logos_pretzu/logo_login.svg'
import imgOnboarding from '../../assets/static/imgOnboarding.svg'
// import { ModalRecoverPassword } from './ModalRecoverPassword'
import { MailOpenIcon } from "lucide-react";


import { fetchSinToken } from '../../helpers/fetch'
import { CircularProgress } from '@mui/material'

export const Onboarding = () => {

    const navigate = useNavigate()

    // const [open, setOpen] = useState(false)
    const [msgError, setMsgError] = useState('')
    const [loading, setLoading] = useState(false)
    const [isValid, setIsvalid] = useState(false)

    const [form, setForm] = useState({
        email: '',
        codigo_activacion: ''
    })

    const validarEmail = async (e) => {
        try {
            e.preventDefault();

            setMsgError('')

            if (form.email === '') {
                setMsgError('El email es requerido')
                return false
            }

            setLoading(true)

            const resp = await fetchSinToken('onboarding/request', form, 'POST');
            const body = await resp.json();

            if (body.ok) {
                setIsvalid(true)
            } else {
                setMsgError(body.msg)
            }

            setLoading(false)

        } catch (error) {

            setMsgError('Error interno')
            console.log(error)

            setLoading(false)

        }

    }

    const confirmarCodigo = async (e) => {
        try {
            e.preventDefault();

            setMsgError('')

            if (form.codigo_activacion === '') {
                setMsgError('Ingresa código de activación para continuar')
                return false
            }

            setLoading(true)

            const resp = await fetchSinToken('onboarding/confirm/code', form, 'POST');
            const body = await resp.json();

            if (body.ok) {

                localStorage.setItem('p-activation-code', body.data.codigo_activacion)
                navigate(`/onboarding/signup`)

            } else {
                setMsgError(body.msg)
            }

            setLoading(false)

        } catch (error) {

            setMsgError('Error interno')
            console.log(error)

            setLoading(false)

        }

    }

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        })
    }

    return (
        <div className='fixed inset-0 flex items-center justify-center'>

            {/* <div className="flex justify-start">
                <img src={logoPretzu} alt="logo pretzu" />
            </div> */}

            <div className='border-1 border-ligthgray-400 rounded-2xl w-[384px]'>

                <div className="">

                    {!isValid &&
                        <>
                            <h1 className='text-[18px] text-center mt-10 text-[#595759]'>Prueba Pretzu durante 14 días</h1>
                            <h3 className='text-[#909090] text-[14px] text-center'>Acceso total, no requieres tarjetas.</h3>

                        </>
                    }

                    {!isValid &&
                        <div className='flex justify-center mt-5'>
                            <img src={imgOnboarding} alt="Person onboarding" />
                        </div>
                    }

                    {!isValid ?
                        <ValidarEmail
                            form={form}
                            handleChange={handleChange}
                            validarEmail={validarEmail}
                            msgError={msgError}
                            loading={loading}
                        />
                        :
                        <ConfirmCode
                            form={form}
                            handleChange={handleChange}
                            confirmarCodigo={confirmarCodigo}
                            msgError={msgError}
                            loading={loading}
                        />
                    }

                </div>
            </div >
        </div >
    )
}


const ValidarEmail = ({ form, handleChange, validarEmail, msgError, loading }) => {

    return (

        <form className='login m-4' onSubmit={validarEmail}>

            {/* <div className='row m-3'>
                <div className="col text-center">
                    <h5 className='p-text-recover-password'>Ingresa tu correo y te enviaremos un código de activación</h5>
                </div>
            </div> */}

            <div className="mb-4">
                <label htmlFor="exampleInputEmail1" className="form-label">Correo electrónico</label>
                <input
                    type="email"
                    name="email"
                    className="form-control p-2 rounded-md"
                    id="loginEmail"
                    placeholder="Ingresa tu correo"
                    value={form.email || ''}
                    onChange={handleChange}
                />
            </div>

            {msgError !== '' &&
                <div style={{ color: 'red', textAlign: 'center', margin: '10px', fontSize: '14px' }}>
                    {msgError}{' '}{msgError === 'Email ya tiene cuenta creada' ? <span><br /><Link to="/login" style={{ color: '#8E24AA' }}>Inicia sesión aquí</Link></span> : ''}
                </div>
            }

            {loading &&
                <div className='text-center'><CircularProgress color="secondary" /></div>
            }

            {!loading &&
                <button
                    type="submit"
                    disabled={form.email === '' ? true : false}
                    className={'btn p-text-enviar d-flex justify-content-center align-items-center mt-4 text-lg p-2 rounded-md'}
                >
                    <span>Continuar</span>
                    <i className="bi bi-arrow-right-short" style={{ fontSize: '20px', fontWeight: 'bold' }}></i>
                </button>
            }

            <div className="mt-4 text-center p-no-registrado">
                ¿Ya tienes una cuenta? <Link to="/login" className="text-[#8E24AA] ms-2 hover:text-[#8E24AA] hover:underline">Inicia sesión</Link>
            </div>

        </form>

    )
}

const ConfirmCode = ({ form, handleChange, confirmarCodigo, msgError, loading }) => {

    return (

        <form className='login m-4' onSubmit={confirmarCodigo}>

            <div className='flex flex-col justify-center items-center'>
                <MailOpenIcon className="w-10 h-10 ms-3 text-[var(--primary-color)]" />
                <h5 className='text-[#595759] md:text-[18px] text-center mt-3 mb-2'>Te hemos enviado un código de verificación a tu correo electrónico {form.email}</h5>
            </div>

            {/* <div className="mb-4 mt-5">
                <label htmlFor="exampleInputEmail1" className="form-label text-base">Correo electrónico</label>
                <input
                    type="email"
                    disabled
                    name="email"
                    className="form-control"
                    id="loginEmail"
                    placeholder="Ingresa tu correo"
                    value={form.email || ''}
                    onChange={handleChange}
                />
            </div> */}

            <div className="mb-4 mt-4">
                <label htmlFor="exampleInputEmail1" className="form-label text-base">Código de verificación</label>
                <input
                    type="text"
                    name="codigo_activacion"
                    className="form-control"
                    id="loginEmail"
                    placeholder="Ingresa tu código de verificación"
                    value={form.codigo_activacion || ''}
                    onChange={handleChange}
                />
            </div>

            {msgError !== '' &&
                < div style={{ color: 'red', textAlign: 'center', margin: '10px', fontSize: '16px' }}>{msgError}</div>
            }

            {loading &&
                <div className='text-center'><CircularProgress color="secondary" /></div>
            }

            {!loading &&
                <button
                    type="submit"
                    disabled={form.codigo_activacion === '' ? true : false}
                    className={'btn p-text-enviar d-flex justify-content-center align-items-center'}
                >
                    <span>CONTINUAR</span>
                    <i className="bi bi-arrow-right-short" style={{ fontSize: '20px', fontWeight: 'bold' }}></i>
                </button>
            }

        </form>

    )
}